import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { acceptFees } from "@/api/v1-jwt/provider-onboarding/provider-onboarding";
import { AcceptFeesPayload } from "./types";
import providerOnboardingQueryKeys from "./query-keys";

interface AcceptFeesParams {
  userId: string;
  applicationId: string;
  providerType: string;
  payload: AcceptFeesPayload;
}

export const useAcceptFees = (
  options?: UseMutationOptions<unknown, Error, AcceptFeesParams>
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  return useMutation<unknown, Error, AcceptFeesParams>({
    mutationFn: ({ userId, applicationId, providerType, payload }) =>
      acceptFees(userId, applicationId, providerType, payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: providerOnboardingQueryKeys.all });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
